import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import TcardsBrandLogo from '../TcardsBrandLogo';
import { TCARDS_HOME_URL } from '../miniwebsite/miniWebsitePaths';
import { DIGITAL_CARD_PATH, PRICING_SECTION_ID, TEMPLATES_CHOOSE_URL } from './digitalCardRoutes';

export const DigitalCardFooter: React.FC = () => {
  const { t } = useTranslation();
  const year = new Date().getFullYear();

  return (
    <footer className="dcl-footer">
      <div className="dcl-container">
        <div className="dcl-footer-grid">
          <div>
            <TcardsBrandLogo href={TCARDS_HOME_URL} showText size={32} tagline="" />
            <p style={{ margin: '12px 0 0', fontSize: 14, lineHeight: 1.6 }}>
              {t('dcl_footer_blurb', { defaultValue: 'Professional digital business cards for modern networking.' })}
            </p>
          </div>
          <div>
            <h4 className="dcl-footer-title">{t('dcl_footer_tcards', { defaultValue: 'TCards' })}</h4>
            <Link to="/digital-card" className="dcl-footer-link">{t('dcl_nav_digital_card', { defaultValue: 'Digital Card' })}</Link>
            <Link to="/templates" className="dcl-footer-link">{t('dcl_nav_templates', { defaultValue: 'Templates' })}</Link>
            <Link to={{ pathname: DIGITAL_CARD_PATH, hash: `#${PRICING_SECTION_ID}` }} className="dcl-footer-link">{t('dcl_nav_pricing', { defaultValue: 'Pricing' })}</Link>
          </div>
          <div>
            <h4 className="dcl-footer-title">{t('dcl_footer_templates', { defaultValue: 'Templates' })}</h4>
            <Link to="/templates/business" className="dcl-footer-link">{t('dcl_cat_business', { defaultValue: 'Business Templates' })}</Link>
            <Link to="/templates/artist" className="dcl-footer-link">{t('dcl_cat_artist', { defaultValue: 'Artist Templates' })}</Link>
          </div>
          <div>
            <h4 className="dcl-footer-title">{t('dcl_footer_company', { defaultValue: 'Company' })}</h4>
            <Link to="/contact" className="dcl-footer-link">{t('dcl_nav_contact', { defaultValue: 'Contact Us' })}</Link>
            <Link to="/privacy" className="dcl-footer-link">{t('dcl_footer_privacy', { defaultValue: 'Privacy Policy' })}</Link>
            <Link to="/terms" className="dcl-footer-link">{t('dcl_footer_terms', { defaultValue: 'Terms of Service' })}</Link>
            <h4 className="dcl-footer-title" style={{ marginTop: 20 }}>{t('dcl_footer_account', { defaultValue: 'Account' })}</h4>
            <Link to="/auth?login=1" className="dcl-footer-link">{t('dcl_nav_sign_in', { defaultValue: 'Sign In' })}</Link>
            <Link to={TEMPLATES_CHOOSE_URL} className="dcl-footer-link">{t('dcl_nav_get_started', { defaultValue: 'Get Started' })}</Link>
          </div>
        </div>
        <div className="dcl-footer-bottom">
          © {year} TCards · {t('dcl_footer_rights', { defaultValue: 'All rights reserved.' })}
        </div>
      </div>
    </footer>
  );
};

export default DigitalCardFooter;
